import HorizontalDivider from "plos/src/components/HorizontalDivider";
import Link from "plos/src/components/links/Link";
import { copy } from "plos/src/styles/copy.css";
import { Trans, useTranslation } from "react-i18next";

const StatusHelp = () => {
  const { t } = useTranslation("help");

  return (
    <div className={copy}>
      <Trans t={t} i18nKey="contextualHelp.status.description">
        <p>
          Your Gameweek points represent the points scored during the current
          round of fixtures. This determines your weekly progress in your
          mini-leagues and whether you’ve gained a green arrow, meaning you have
          gained overall rank, or a red arrow, meaning you have lost overall
          rank.
        </p>
        <p>
          The Gameweek deadline in days, hours and minutes is the time remaining
          before your line-up for the next Gameweek needs to be confirmed. If
          you do not submit your squad line-up by this point, your previous
          line-up will be used.
        </p>
      </Trans>
      <HorizontalDivider />
      <Link
        href={`${import.meta.env.VITE_HF_BASE}/en/news/2683145/fpl-glossary`}
        target="_blank"
      >
        {t(
          "contextualHelp.status.fantasyTermsExplained",
          "Fantasy terms explained",
        )}
      </Link>
    </div>
  );
};

export default StatusHelp;
